/**
 * Canonical movement constants for Fall Line.
 *
 * Conventions (do not deviate — see docs/reference/MOVEMENT.md):
 * - 1 world unit = 1 Hammer unit (Source engine scale).
 * - Y is up (Source is Z-up; we translate). -Z is forward at yaw 0.
 * - All speeds are units/second; the simulation runs at a fixed tick.
 */

/** Downward acceleration, u/s^2 (Source sv_gravity). */
export const GRAVITY = 800;

/** Air acceleration multiplier. Surf servers run 150 (CS default 10 cannot surf well). */
export const AIR_ACCELERATE = 150;

/** Ground acceleration multiplier (Source sv_accelerate). */
export const GROUND_ACCELERATE = 5.5;

/** Ground friction (never applied in air). */
export const FRICTION = 4;

/** Friction control floor, u/s (Source sv_stopspeed). */
export const STOP_SPEED = 75;

/** Max ground wishspeed, u/s. */
export const MAX_SPEED = 260;

/**
 * Wishspeed clamp while airborne, u/s. The "magic 30": because acceleration only
 * limits the projection of velocity onto the wish direction, a small cap plus
 * mouse turning lets total speed grow without bound — this is air-strafing.
 */
export const AIR_CAP = 30;

/** Hard per-axis velocity clamp, u/s (Source sv_maxvelocity). */
export const MAX_VELOCITY = 3500;

/** Initial jump velocity, u/s: sqrt(2 * 800 * 45) for a 45-unit apex. */
export const JUMP_VELOCITY = 268.3;

/**
 * A contact plane is ground when its normal's Y exceeds this; below it the
 * plane is surfable (no friction, slide via clipVelocity). 0.7 ~= 45.6 deg.
 */
export const SURF_NORMAL_Y = 0.7;

/** Overbounce factor for clipVelocity. Quake uses 1.001; start neutral, tune in Phase 2. */
export const OVERCLIP = 1.0;

/** Fixed simulation rate. Air-strafe physics is tickrate-sensitive; never simulate on frame dt. */
export const TICK_RATE = 100;
export const TICK_DT = 1 / TICK_RATE;

/** Player capsule (Source hull 32x32x72 translated to a capsule). */
export const PLAYER_RADIUS = 16;
export const PLAYER_HEIGHT = 72;
export const EYE_HEIGHT = 64;
